import Axios, { AxiosError, CreateAxiosDefaults } from "axios";
import { ErrorType } from "../react-query";
import { store } from "../../store";
import { PUBLIC_API } from "./constant";
import { notification } from "../../utils/notification";

const { dashboard } = store.getState();
const config: CreateAxiosDefaults = {
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: dashboard.token
    ? {
        Authorization: `Bearer ${dashboard.token}`,
      }
    : undefined,
};
const axios = Axios.create(config);
axios.interceptors.request.use(
  (config) => {
    const token = store.getState().dashboard.token;
    const IS_PUBLIC_API = PUBLIC_API.some((item) => {
      return item === config.url;
    });

    if (!IS_PUBLIC_API) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      config.headers.Authorization = null;
    }
    return config;
  },
  (error: AxiosError<ErrorType>) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    notification(error.response?.data.Message || error.message, "error");
    if (error.response.status === 401) {
      window.location.href = "/error-unauthorize";
    }
    return Promise.reject(error);
  }
);

fetch("/config.json")
  .then((response) => response.json())
  .then((data) => {
    axios.defaults.baseURL = data.apiBaseUrl;
  })
  .catch((error) => {
    console.error("Error loading configuration:", error);
  });

export default axios;
